import { AxiosResponse } from "axios";
import { microserviceApiAxios } from "../../microservice-api.axios";
import { microserviceApiRoutes } from "../../microservice-api.routes";

export const getAgentsList = () => {
  const url = microserviceApiRoutes.v1.agents.user.list();
  return microserviceApiAxios.get(url).then((res) => res.data);
};

export const getAgentById = (id: string) => {
  const url = microserviceApiRoutes.v1.agents.user.getByID(id);
  return microserviceApiAxios.get(url).then((res) => res.data);
};

export const getListRoles = () => {
  const url = microserviceApiRoutes.v1.agents.roles.list();
  return microserviceApiAxios.get(url).then((res) => res.data);
};

export const updateAgent = (data: any, id: string) => {
  const url = microserviceApiRoutes.v1.agents.user.update(id);
  return microserviceApiAxios.post(url, data).then((res) => res.data);
};

export const createAgent = (data: any) => {
  const url = microserviceApiRoutes.v1.agents.user.create();
  return microserviceApiAxios.post(url, data).then((res) => res.data);
};

export const changeStatusAgent = (userID: string) => {
  const url = microserviceApiRoutes.v1.agents.user.changeStatus();
  return microserviceApiAxios.post(url, { userID }).then((res) => res.data);
};
